import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCityId, getLocationId } from '../redux/selectors';
import { selectCity, selectLocation, setStepValidated } from '../redux/actions';
import { useRequiredBookingContext } from './useBookingContext';

export default function useUpdateCityAndLocationId() {
    const { location } = useRequiredBookingContext();

    const dispatch = useDispatch();
    const stateCityId = useSelector(getCityId);
    const stateLocationId = useSelector(getLocationId);
    const locationId = location._id;
    const cityId = location.city?.cityId ?? '';

    React.useEffect(() => {
        if (stateCityId !== cityId) {
            dispatch(selectCity(cityId));
            dispatch(setStepValidated('city', true));
        }
        if (stateLocationId !== locationId) {
            dispatch(selectLocation(locationId));
            dispatch(setStepValidated('location', true));
        }
    }, [dispatch, cityId, locationId, stateCityId, stateLocationId]);
}
